import React from 'react';
import Icon from '../../../components/AppIcon';

const SkillProgressCard = ({ skill, level, progress, endorsements, icon }) => {
  const getLevelColor = (level) => {
    const colors = {
      'Beginner': 'text-accent',
      'Intermediate': 'text-secondary',
      'Advanced': 'text-primary',
      'Expert': 'text-success'
    };
    return colors?.[level] || 'text-muted-foreground';
  };

  return (
    <div className="bg-card rounded-lg p-4 border border-border hover:shadow-sm transition-all">
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
            <Icon name={icon} size={20} className="text-primary" />
          </div>
          <div>
            <h4 className="font-semibold text-foreground">{skill}</h4>
            <p className={`text-sm font-medium ${getLevelColor(level)}`}>{level}</p>
          </div>
        </div>
        <div className="flex items-center gap-1 text-sm text-muted-foreground">
          <Icon name="Users" size={14} />
          <span>{endorsements}</span>
        </div>
      </div>
      <div className="space-y-2">
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">Progress</span>
          <span className="font-medium text-foreground">{progress}%</span>
        </div>
        <div className="w-full bg-muted rounded-full h-2 overflow-hidden">
          <div 
            className="h-full bg-gradient-to-r from-primary to-secondary rounded-full transition-all duration-500"
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>
    </div>
  );
};

export default SkillProgressCard;